export const PROPERTY_IMAGE_VERSION_CONFLICT =
  'PROPERTY_IMAGE_VERSION_CONFLICT';

export type EnhancedVersion = {
  kind: 'draft';
  id: string;
  imageData: string;
  blobUrl: string;
  prompt: string;
  sourceImageId: string | null;
  sourceVersion: ListingImageVersionSource;
};

export type ListingImageVersionSource = 'original' | 'saved_ai' | 'draft_ai';

export type ListingImageVersion = {
  kind: 'saved';
  id: string;
  imageId: string;
  imageUrl: string | null;
  sourceImageId: string | null;
  prompt: string | null;
  createdAt: string;
};

export type SaveListingImageVersionInput = {
  imageData: string;
  prompt: string;
  sourceImageId: string | null;
  expectedCurrentImageId: string;
};

export type SaveListingImageVersion = (
  propertyImageId: string,
  input: SaveListingImageVersionInput,
) => Promise<void>;

export type ActivateListingImageVersion = (
  propertyImageId: string,
  imageId: string,
  expectedCurrentImageId: string,
) => Promise<void>;

export type ListingImageVersioning = {
  propertyImageId: string;
  currentImageId: string;
  initialVersionImageId?: string;
  savedVersions: ListingImageVersion[];
  onSaveVersion: SaveListingImageVersion;
  onUseVersion: ActivateListingImageVersion;
};

export type EnhanceImage = {
  id: string;
  url: string;
};

/** Second-level filter under a main category (e.g. listing photography vs agent headshots). */
export type EnhanceSubcategory = {
  id: string;
  label: string;
  categoryId: string;
  emoji?: string;
};

export type EnhancePanelAction = {
  id: string;
  label: string;
  emoji: string;
  description: string;
  prompt: string;
  /** Called on each click to produce a dynamic prompt (e.g. random color). */
  getPrompt?: () => string;
  category: string;
  subcategory?: string;
};

export type EnhanceCategory = {
  id: string;
  label: string;
  emoji: string;
};

type EnhanceImagePanelCommonProps = {
  open: boolean;
  onClose: () => void;
  image: EnhanceImage | null;
  onEnhance: (
    prompt: string,
    sourceImageData: string,
  ) => Promise<{ image_data: string }>;
  source?: 'profile' | 'property';
  maxImageDimension?: number;
  actions: EnhancePanelAction[];
  categories: EnhanceCategory[];
  subcategories: EnhanceSubcategory[];
};

type EnhanceImageSaveStrategy =
  | {
      onSaveImages: (base64Images: string[]) => Promise<void>;
      listingVersioning?: never;
    }
  | {
      onSaveImages?: never;
      listingVersioning: ListingImageVersioning;
    };

export type EnhanceImagePanelProps = EnhanceImagePanelCommonProps &
  EnhanceImageSaveStrategy;
